import { render, staticRenderFns } from "./PlacePreview.vue?vue&type=template&id=2fb73967&scoped=true&"
import script from "./PlacePreview.vue?vue&type=script&lang=js&"
export * from "./PlacePreview.vue?vue&type=script&lang=js&"
import style0 from "./PlacePreview.vue?vue&type=style&index=0&id=2fb73967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb73967",
  null
  
)

export default component.exports